import React from 'react';

const ButtonTypeUser = ({ title, Icon, isSelected, onClick }) => {
  return (
    <button
      onClick={onClick}
      className={`flex flex-col justify-center items-center gap-3 p-8 flex-1 rounded-lg bg-[#26262D]  backdrop-blur-lg ${
        isSelected ? 'border border-white' : 'border-0'
      }`}
    >
      {Icon && <Icon className="w-9 h-9 text-white" />}
      <span className="text-white text-sm">{title}</span>
    </button>
  );
};

export default ButtonTypeUser;


/* 
como utilizarlo para

import React, { useState } from 'react';
import ButtonTypeUser from './ButtonTypeUser';
import { ReactComponent as Icon1 } from './path/to/icon1.svg';
import { ReactComponent as Icon2 } from './path/to/icon2.svg';

const ButtonGroup = () => {
  const [selectedButton, setSelectedButton] = useState(null);

  return (
    <div className="flex space-x-4">
      <ButtonTypeUser
        title="Opción 1"
        Icon={Icon1}
        isSelected={selectedButton === 'option1'}
        onClick={() => setSelectedButton('option1')}
      />
      <ButtonTypeUser
        title="Opción 2"
        Icon={Icon2}
        isSelected={selectedButton === 'option2'}
        onClick={() => setSelectedButton('option2')}
      />
    </div>
  );
};

export default ButtonGroup;


*/